import Reveal from "@/components/base/Reveal";
import Eyebrow from "@/components/base/Eyebrow";
import { beforeAfter } from "@/mocks/site";
import { buildWhatsAppLink } from "@/utils/links";

export default function BeforeAfterSection() {
  return (
    <section id="resultados" className="relative overflow-hidden bg-background-100">
      <div className="pointer-events-none absolute -left-24 top-24 h-[360px] w-[360px] rounded-full glow-clinic blur-3xl" />
      <div className="pointer-events-none absolute -right-20 bottom-20 h-[340px] w-[340px] rounded-full glow-beige blur-3xl" />
      <div className="relative mx-auto w-full max-w-[1400px] px-5 py-20 md:px-10 md:py-28">
        <Reveal className="max-w-2xl">
          <Eyebrow>Evidencia ALÉA</Eyebrow>
          <h2 className="mt-3 font-heading text-4xl font-bold leading-[1.05] text-foreground-950 md:text-5xl">
            Antes y después
          </h2>
          <p className="mt-5 text-[15px] leading-relaxed text-foreground-600">
            Resultados reales de protocolos con valoración previa. Cada piel responde distinto:
            cuidamos la expectativa antes de prometer.
          </p>
        </Reveal>

        <div className="mt-12 grid grid-cols-1 gap-6 md:grid-cols-3">
          {beforeAfter.map((item, index) => (
            <Reveal key={item.title} delay={index * 100} className="flex">
              <article className="card-soft group relative flex w-full flex-col overflow-hidden rounded-[24px] border border-secondary-200 bg-background-50 transition-all duration-500 hover:-translate-y-1 hover:card-premium">
                <div className="grid grid-cols-2 gap-px bg-secondary-200">
                  <div className="relative h-[240px] overflow-hidden bg-background-100">
                    <img
                      src={item.before}
                      alt={`Antes — ${item.title} en ALÉA Aesthetic House`}
                      title={`Antes ${item.title} tratamientos estéticos Culiacán`}
                      className="h-full w-full object-cover object-top"
                    />
                    <span className="absolute left-3 top-3 rounded-full bg-background-50/90 px-3 py-1 font-label text-[10px] font-semibold uppercase tracking-[0.14em] text-foreground-700 backdrop-blur-sm">
                      Antes
                    </span>
                  </div>
                  <div className="relative h-[240px] overflow-hidden bg-background-100">
                    <img
                      src={item.after}
                      alt={`Después — ${item.title} en ALÉA Aesthetic House`}
                      title={`Después ${item.title} tratamientos estéticos Culiacán`}
                      className="h-full w-full object-cover object-top"
                    />
                    <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 font-label text-[10px] font-semibold uppercase tracking-[0.14em] text-background-50">
                      Después
                    </span>
                  </div>
                </div>

                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-heading text-lg font-bold leading-snug text-foreground-950">
                    {item.title}
                  </h3>
                  <p className="mt-1.5 text-sm text-foreground-500">{item.protocol}</p>
                </div>
              </article>
            </Reveal>
          ))}
        </div>

        <Reveal delay={120} className="relative mt-10 flex flex-col items-start justify-between gap-5 overflow-hidden rounded-[24px] border border-secondary-200 bg-background-50 px-7 py-7 sm:flex-row sm:items-center md:px-10">
          <span className="absolute inset-x-0 top-0 h-px line-gold" />
          <p className="max-w-xl text-sm leading-relaxed text-foreground-600">
            Resultados pueden variar según valoración y protocolo.
          </p>
          <a
            href={buildWhatsAppLink("Hola ALÉA, quiero agendar una valoración para ver resultados.")}
            target="_blank"
            rel="noreferrer"
            className="cta-primary inline-flex min-h-[48px] shrink-0 items-center gap-2 whitespace-nowrap rounded-[16px] bg-primary-500 px-6 font-label text-[11px] font-semibold uppercase tracking-[0.14em] text-background-50 transition-all duration-300 hover:bg-primary-600"
          >
            Agendar valoración
            <i className="ri-whatsapp-line text-base" />
          </a>
        </Reveal>
      </div>
    </section>
  );
}